import React, { useEffect, useState } from 'react'
import { FormGroup, ControlLabel, Row, Col } from 'react-bootstrap'
import { Field, ErrorMessage } from 'formik'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

// Date picker
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import MomentUtils from '@date-io/moment'
import { MuiThemeProvider } from "@material-ui/core"
import hoopstirTheme from '../CSSOverrides'

export function AccountHolderDetails(props) {
  const [emailHint, setEmailHint] = useState(false);

  const { disabled, email, DOB, setFieldValue, handleDate, EF1 } = props
  return (
    <div data-testid="AH-details">


          <h3>
            <img className="num-icon half" src={EF1 ? "2.png" : "2.png"}></img>
            {EF1 ? 'Account Holder ': 'Account Holder' }
            </h3>
    

      <Row className="enrolment-row">
        <Col sm={3}>
          <FormGroup>
            <ControlLabel>First Name</ControlLabel>
            <Field name="AH_first_name" id="AH_first_name" className="opaque-grey form-control" disabled={disabled}/>
            <ErrorMessage component="div" name="AH_first_name" className="invalid-feedback"/>
          </FormGroup>
        </Col>
        <Col sm={3}>
          <FormGroup>
            <ControlLabel>Last Name</ControlLabel>
            <Field name="AH_last_name" id="AH_last_name"  className="opaque-grey form-control" disabled={disabled}/>
            <ErrorMessage component="div" name="AH_last_name" className="invalid-feedback"/>
          </FormGroup>
        </Col>
        <Col sm={2}>
          <FormGroup>
            <ControlLabel>Phone</ControlLabel>
            <Field name="AH_phone" id="AH_phone" className="opaque-grey form-control" disabled={disabled}/>
            <ErrorMessage component="div" name="AH_phone" className="invalid-feedback"/>
          </FormGroup>
        </Col>
        <Col sm={2}>
          <FormGroup>
            <ControlLabel style={{display: 'inline-block'}}>E-mail</ControlLabel>
            <a className="hint-tip" onClick={() => setEmailHint(!emailHint)}>
              <FontAwesomeIcon icon={faInfoCircle} color='white'/>
              {
                emailHint ?
              <div className="hint-tip-text" id="name-hint">
                <span>To edit your email please go back and sign in again.</span>
              </div>
              : ''
              }
            </a>
            <Field name="AH_email" className="opaque-grey form-control" disabled value={email}/>
          </FormGroup>
        </Col>
        <Col sm={2}>
          <FormGroup>
            <ControlLabel>Date of Birth</ControlLabel>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <MuiThemeProvider theme={hoopstirTheme}>
                <DatePicker disableFuture openTo="year" format="MM/DD/YYYY" clearable views={["year", "month", "date"]}
                value={DOB} 
                className="DOB" name="AH_DOB" id="AH_DOB"
                onChange={(val) => handleDate(val, setFieldValue)}
                disabled={disabled}
                />
              </MuiThemeProvider>
            </MuiPickersUtilsProvider>
            <ErrorMessage component="div" name="AH_DOB" className="invalid-feedback"/>
          </FormGroup>
        </Col>
      </Row>
      <Row className="enrolment-row">
        <Col sm={3}>
          <FormGroup>
            <ControlLabel>{EF1 && "Home"} Address</ControlLabel>
            <Field name="AH_address" id="AH_address" className="opaque-grey form-control" disabled={disabled}/>
            <ErrorMessage component="div" name="AH_address" className="invalid-feedback"/>
          </FormGroup>
        </Col>
        <Col sm={3}>
          <FormGroup>
            <ControlLabel>City</ControlLabel>
            <Field name="AH_city" id="AH_city" className="opaque-grey form-control" disabled={disabled}/>
            <ErrorMessage component="div" name="AH_city" className="invalid-feedback"/>
          </FormGroup>
        </Col>
        <Col sm={2}>
          <ControlLabel>Country</ControlLabel>
          <Field name="AH_country" id="AH_country" className="opaque-grey form-control" disabled={disabled}/>
          <ErrorMessage component="div" name="AH_country" className="invalid-feedback"/>
        </Col>
        <Col sm={2}>
          <FormGroup>
            <ControlLabel>Province/State</ControlLabel>
            <Field name="AH_province" id="AH_province" className="opaque-grey form-control" disabled={disabled}/>
            <ErrorMessage component="div" name="AH_province" className="invalid-feedback"/>
          </FormGroup>
        </Col>
        <Col sm={2}>
          <FormGroup>
            <ControlLabel>Postal/Zip Code</ControlLabel>
            <Field name="AH_postal" id="AH_postal" className="opaque-grey form-control" disabled={disabled}/>
            <ErrorMessage component="div" name="AH_postal" className="invalid-feedback"/>
          </FormGroup>
        </Col>
      </Row>
    </div>
  )
}
